<div class="container">
  <div class="row">
    @if (accountType === 'INT' || accountType === 'HLP') {
      <div class="col-md-12 px-3">
        <br />
        <h1>{{'DISCOUNT_SHEET' | translate}}</h1>
        <div class="row">
          @for (company of companies; track company) {
            <!-- WS -->
            @if (company.companyID === 'WS' && router.url.includes('WS')) {
              <div class="col-12">
                <h2>Winora-Staiger</h2>
                <div class="d-block mb-2">
                  <button class="btn btn-dark mb-3" (click)="downloadPdf('WS')">{{'DOWNLOAD_PDF' | translate}}</button>
                </div>
                <div class="d-flex w-100">
                  @if (company.fileURL) {
                    <pdf-viewer [src]="company.fileURL" class="border border-dark w-100"></pdf-viewer>
                  }
                </div>
              </div>
            }
            <!-- WBP -->
            @if (company.companyID === 'WBP' && router.url.includes('WBP')) {
              <div class="col-12">
                <h2>E. Wiener Bike Parts </h2>
                <div class="d-block mb-2">
                  <button class="btn btn-dark mb-3" (click)="downloadPdf('WBP')">{{'DOWNLOAD_PDF' | translate}}</button>
                </div>
                <div class="d-flex w-100">
                  @if (company.fileURL) {
                    <pdf-viewer [src]="company.fileURL" class="border border-dark w-100"></pdf-viewer>
                  }
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
